import PageSignUp from './components/SignUp';

export default PageSignUp;


// WEBPACK FOOTER //
// ./routes/sign-up/index.js